import { render, staticRenderFns } from "./nWordStar.vue?vue&type=template&id=8a0dd9ca&"
import script from "./nWordStar.vue?vue&type=script&lang=ts&"
export * from "./nWordStar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports